/**
 * 厅战榜单
 */

import React from 'react';
import styled from 'styled-components';
import times from 'lodash/times';
import cls from 'classnames';
import { useStateful } from 'react-hanger';

import { UiModal } from '@/components';
import { hooks, request, utils } from '@/lib';
import { room } from '@/modules/widgets/lib';

const PopupRank = (props) => {
  const tab = useStateful(props.tab || 0);

  const { data: list = [] } = hooks.useSimpleFetch(() => {
    return request.funny.get('api/v1/multiRoom/war/rank', {
      roomId: room.getRoomId(),
      type: tab.value,
    });
  }, [tab.value]);

  return (
    <Wrap {...props} width={460} title="PK贡献榜" isShowFooter={false}>
      <ul className="header-tabs">
        {['我方榜单', '对方榜单'].map((text, i) => (
          <li
            key={i}
            className={cls({ active: i === tab.value })}
            onClick={() => tab.setValue(i)}
          >
            {text}
          </li>
        ))}
      </ul>
      <ul className="list">
        {times(5, (i) => {
          const item = list[i] || {};
          return (
            <li className="item" key={i}>
              <i className={`rank rank-${i + 1}`}>{i + 1 > 3 ? i + 1 : ''}</i>
              <img
                className="avatar"
                src={item.avatar || require('../images/icon-empty.png')}
              />
              <span className="nick text-overflow">
                {item.nickname || '虚位以待'}
              </span>
              <span className="value">
                {item.lemon ? utils.formatNum(item.lemon, true) : '--'}
              </span>
            </li>
          );
        })}
      </ul>
    </Wrap>
  );
};

const Wrap = styled(UiModal)`
  color: #fff;

  .modal-title,
  .icon-close {
    color: #fff;
  }

  .inner {
    background: #3e454d url(${require('../images/bg-popup-result.png')})
      no-repeat top / contain !important;
  }
  .nick {
    color: #fff;
  }
  .inner {
    border-radius: 4px;
  }
  .ui-modal-header {
    border-bottom: 0;
  }
  .ui-modal-body {
    padding-top: 6px;
    min-width: auto;
  }

  .header-tabs {
    width: 184px;
    height: 34px;
    margin: 0 auto 10px;
    padding: 0 2px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    text-align: center;
    color: #fff;
    li {
      flex: 1;
      cursor: pointer;
    }
    .active {
      height: 30px;
      line-height: 30px;
      background-color: #b95eff;
      border-radius: 30px;
    }
  }

  .item {
    height: 74px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #fff;
  }
  .rank {
    width: 30px;
    height: 30px;
    font-style: normal;
    text-align: center;
    font-weight: 700;
    color: #ffffff;
    &-1 {
      background: url(${require('../images/icon-no-1.png')}) no-repeat left /
        contain;
    }
    &-2 {
      background: url(${require('../images/icon-no-2.png')}) no-repeat left /
        contain;
    }
    &-3 {
      background: url(${require('../images/icon-no-3.png')}) no-repeat left /
        contain;
    }
  }
  .avatar {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    margin-left: 8px;
  }
  .nick {
    max-width: 130px;
    margin-left: 4px;
  }
  .value {
    margin-left: auto;
  }
`;

export default PopupRank;
